import { forwardRef } from 'react';
import { RootComponent } from '../../../../services/root-component';
import { LayoutProps } from '../../types';
import css from './style.module.css';

export const Layout = forwardRef<HTMLElement, LayoutProps>(function Component(
  { children, ...props },
  forwardedRef
) {
  return (
    <RootComponent
      {...props}
      Component="nav"
      baseClassName={css.root}
      ref={forwardedRef}
    >
      {children}
    </RootComponent>
  );
});
